import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
